import React from 'react'
import styled from 'styled-components'
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import LinearProgress from '@mui/material/LinearProgress';

import WeeklyGraph from './WeeklyGraph';

const moment = require('moment-timezone');
const ModalBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  height: 60vh;
  background: linear-gradient(160deg,#222222 15%, #333333 60%,  #222222);
  border: 2px solid #000;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 16px;

  color: white;

  color: #e0e0e0;
  font-family: "Inter";

  border: 2px solid #4a4a4a;
  border-radius: 15px;

`;

const ModalTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 2rem;
`

const ModalBody = styled.div`
  display: flex;
`

const BreakdownContainer = styled.div`
  flex: 1;

  height: 50vh;

  display: flex;
  align-items: center;
  
  flex-direction: column;

  gap: 2vh;
`

const BreakdownTitle = styled.div`
  width: 100%;
  padding-left: 1vw;
  padding-top: 1vw;
  font-size: 1.2rem;
`

const BreakdownGraph = styled.div`

  border: 2px solid #4a4a4a;
  border-radius: 15px;

  width: calc(100% - 2vw);

  height: 70%;

  display: flex;

  padding-left: 1vw;
  padding-right: 1vw;
  padding-top: 2vw;

  align-items: center;
  justify-content: center;
`

const BreakdownDataContainer = styled.div`
  flex: 1;
  margin-bottom: 2vh;
  width: calc(100% - 2vw);
  display: flex;

  gap: 1vw;
`

const BreakdownDataBox = styled.div`

  border: 2px solid #4a4a4a;
  border-radius: 15px;
  flex: 1;
  padding: 1vw;

  display: flex;
  align-items: center;
  flex-direction: column;
`
export default function BreakdownModal({ handleClose, department}) {

  function getMondayOfLastWeek() {
    let date = new Date();
    date.setDate(date.getDate() - ((date.getDay() + 6) % 7) - 7);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }

  function getMondayAfterLastWeek() {
    let date = moment().tz("Australia/Sydney");
    let daysToSubtract = date.day() === 0 ? 7 : date.day();
    date.subtract(daysToSubtract - 1, 'days'); // subtracting one less to get to Monday
    return date.format('YYYY-MM-DD');
  }

  function getSundayOfLastWeek() {
    let date = new Date();
    let daysToSubtract = date.getDay() === 0 ? 7 : date.getDay();
    date.setDate(date.getDate() - daysToSubtract);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }

  const [employeeHoursData, setEmployeeHoursData] = React.useState({});

  const getDepartmentData = async () => {
    const weekStart = await getMondayOfLastWeek();
    let weekEnd = await getSundayOfLastWeek();
    if (department === "Traffic") {
      weekEnd = await getMondayAfterLastWeek();
    }
    try {
      const response = await fetch(`https://ic360portalbackend.azurewebsites.net/api/masterDashboard/weeklyData/${department}/${weekStart}/${weekEnd}/breakdown`)

      if (!response.ok) {
        console.log("Error fetching data from backend", response.statusText);
        return null;
      }
      
      const data = await response.json();
      console.log(data);

      setEmployeeHoursData(data);
    } catch(error) {
      console.error("Error fetching the data", error)
    }
  }

  React.useEffect(()=>{
    getDepartmentData()
  },[])

  return (
    <ModalBox>
      <ModalTitle>
        <div>DAILY BREAKDOWN <span style={{textTransform: "uppercase"}}>{department}</span></div>
        <IconButton onClick={() => { handleClose() }}><CloseIcon sx={{ color: "white", fontSize: "2rem" }} /></IconButton>
      </ModalTitle>
      <ModalBody>
        <BreakdownContainer>
          <BreakdownTitle>HOURS</BreakdownTitle>
          <BreakdownGraph>
            <WeeklyGraph weeklyData={employeeHoursData} category={"Hours"}/>
          </BreakdownGraph>
          <BreakdownDataContainer>
            <BreakdownDataBox>CURRENT TOTAL</BreakdownDataBox>
            <BreakdownDataBox>TARGET</BreakdownDataBox>
          </BreakdownDataContainer>
        </BreakdownContainer>
        <BreakdownContainer>
          <BreakdownTitle>WORKERS</BreakdownTitle>
          <BreakdownGraph>
            <WeeklyGraph weeklyData={employeeHoursData} category={"Employees"}/>
          </BreakdownGraph>
          <BreakdownDataContainer>
            <BreakdownDataBox>CURRENT TOTAL</BreakdownDataBox>
            <BreakdownDataBox>TARGET</BreakdownDataBox>
          </BreakdownDataContainer>
        </BreakdownContainer>
        <BreakdownContainer>
          <BreakdownTitle>ASSETS</BreakdownTitle>
          <BreakdownGraph>
            GRAPH
          </BreakdownGraph>
          <BreakdownDataContainer>
            <BreakdownDataBox>CURRENT</BreakdownDataBox>
            <BreakdownDataBox>TARGET</BreakdownDataBox>
          </BreakdownDataContainer>
        </BreakdownContainer>
      </ModalBody>
    </ModalBox>
  )
}
